import "./instrument";
import React from "react";
import { createRoot } from "react-dom/client";
import "./app/styles/index.scss";
import App from "./app/App";

// Полифилл для Promise.withResolvers
if (!Promise.withResolvers) {
  Promise.withResolvers = function <T>(): PromiseWithResolvers<T> {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: any) => void;
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

// Полифилл для URL.parse
if (!URL.parse) {
  URL.parse = function (url: string, base?: string | URL): URL | null {
    try {
      return new URL(url, base);
    } catch {
      return null;
    }
  };
}

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(React.createElement(App));
